module.exports = __webpack_public_path__ + "static/Tritech_2-93a46aa466a605436396d99d1b93adbe.svg";